import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Icon, Button, Segment, Dimmer, Loader, Grid} from 'semantic-ui-react';
import {convertDateToSpecificFormat} from '../../../../common/util/date';
import {Actions} from '../../../../common/actions';
import {isEmpty} from 'lodash';

class ChassisInfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
  }

  fetchData = () => {
    const {item} = this.props;
    this.props.clearChassisInfo();
    if (item.chassis) {
      this.props.fetchChassisInfo(item.chassis);
    }
    this.setState({'modalWasOpen': true});
  }

  onCloseModalClick = () => {
    this.setState({'modalWasOpen': false});
  }

  renderLoaderOrData = () => {
    const {loading} = this.props;
    if (loading) {
      return (
        <Segment>
          <Dimmer active inverted>
            <Loader active inline='centered' />
          </Dimmer>
        </Segment>
      );
    }
    return <Grid textAlign='left'>{this.renderInfoChassis()}</Grid>;
  }

  renderInfoChassis = () => {
    const {chassisInfo, item} = this.props;
    if (isEmpty(chassisInfo) && isEmpty(item)) {
      return <div>No hay Información del chasis</div>;
    }

    const data = [
      {
        'firstLabel': 'Pedido',
        'firstValue': chassisInfo.order,
        'secondLabel': 'Color Externo',
        'secondValue': item.externalColorCode,
      },
      {
        'firstLabel': 'Facturar a',
        'firstValue': item.invoiceTo,
        'secondLabel': 'Color Interno',
        'secondValue': item.internalColorCode,
      },
      {
        'firstLabel': 'Cliente Final',
        'firstValue': chassisInfo.clientName,
        'secondLabel': 'F. Movilización',
        'secondValue': convertDateToSpecificFormat(item.mobilizationDate),
      },
      {
        'firstLabel': 'Tipo Venta',
        'firstValue': chassisInfo.saleType,
        'secondLabel': 'F. Hunter',
        'secondValue': convertDateToSpecificFormat(item.hunterDate),
      },
      {
        'firstLabel': 'Número Factura',
        'firstValue': chassisInfo.invoice || chassisInfo.saleDocumentNumber,
        'secondLabel': 'F. Accesorios',
        'secondValue': convertDateToSpecificFormat(item.accDate),
      },
      {
        'firstLabel': 'Año modelo',
        'firstValue': item.modelYear,
        'secondLabel': 'F. PDS',
        'secondValue': convertDateToSpecificFormat(item.pdsDate),
      },
    ];

    return data.map((element, index) => {
      return (
        <Grid.Row key={index}>
          <Grid.Column width={3}>
            <h3>{element.firstLabel}</h3>
          </Grid.Column>
          <Grid.Column width={4}>{element.firstValue}</Grid.Column>
          <Grid.Column width={2} />
          <Grid.Column width={3}>
            <h3>{element.secondLabel}</h3>
          </Grid.Column>
          <Grid.Column width={4}>{element.secondValue}</Grid.Column>
        </Grid.Row>
      );
    });
  }

  render() {
    const {modalWasOpen} = this.state;
    const {item} = this.props;

    return (
      <Modal
        size='large'
        onOpen={() => this.fetchData()}
        className='chassis-info-modal'
        open={modalWasOpen}
        trigger={
          <span>
            <Icon name='eye' size='large' color='blue' />
          </span>
        }
      >
        <Modal.Header>
          Información adicional del chasis: {item.chassis}
        </Modal.Header>

        <Modal.Content>
          <Modal.Description>{this.renderLoaderOrData()}</Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button positive onClick={this.onCloseModalClick}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.vehicleEfficiency.loadingChassisInfo,
    'chassisInfo': state.vehicleEfficiency.chassisInfo,
  };
};

const {
  clearChassisInfo,
  fetchChassisInfo,
} = Actions;

export default connect(mapStateToProps, {
  clearChassisInfo,
  fetchChassisInfo,
})(ChassisInfoModal);
